import React, { useEffect, useState } from "react"
import { Typography, Card, CardContent, Button, useMediaQuery } from "@mui/material"
import { useAppData } from "../../../context/AppDataContext" // In App related Data
import VAPieChart from "../../../components/VAPieChart"
import { toast } from "react-toastify"
import SalesLineChart from "./SalesLineChart"
import dayjs from "dayjs"
import { useVariableData } from "../../../context/VariableDataContext"
import { useDemo } from "../../../context/DemoContext"

import AppealsInfo from "./AppealsInfo"
import AppealsPie from "./AppealsPie"
import EmployeeList from "./EmployeeList"
import AppealsInfoGroupBy from "./AppealsInfoGroupBy"

import "./index.css"
import DemoQuestionnaireModal from "./DemoQuestionnaireModal"
import SmartFeedbackSystem from "./SmartFeedbackSystem"
const STORAGE_KEY = "va_feedback_prompt_dismissed"

const currentDayjs = dayjs()

function BoostDash() {
  const { hasDemoAccess, demoData, feedbackSubmitted } = useDemo()

  const [salesInfo, setSalesInfo] = React.useState(null)
  const [appealsInfo, setAppealsInfo] = React.useState(null)
  const [openModal, setOpenModal] = useState(false)
  const { feedbackTimerStarted } = useDemo()

  const handleCTAClick = () => setOpenModal(true)

  const handleOpenSchedule = () => window.open("https://calendly.com/farhan-prepaidrecon/30min", "_blank")

  const handleModalClose = () => {
    handleDismiss()
    setOpenModal(false)
  }

  const handleQuestionnaireSubmit = async (answers) => {
    try {
      // Send answers to your backend API
      await fetch("/api/demo-questionnaire", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...answers, email: demoData?.email }),
      })

      // Then open Calendly
      window.open("https://calendly.com/farhan-prepaidrecon/30min", "_blank")
      setOpenModal(false)
    } catch (error) {
      console.error(error)
      toast.error("Failed to submit questionnaire. Please try again.")
    }
  }

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now())
  }

  const isMobile = useMediaQuery("(max-width:500px)")

  useEffect(() => {
    if (hasDemoAccess && demoData) {
      setAppealsInfo(demoData.appealsInfo?.[0] || {})
    }
  }, [hasDemoAccess, demoData])

  const convertToChartData = (info) => {
    let chartData = []
    if (info) {
      chartData = [
        { id: 0, value: info.AccumulatedExtCost, label: "Ext Cost" },
        { id: 1, value: info.AccumulatedGP, label: "Gross Profit" },
        { id: 2, value: info.AccumulatedTax, label: "Tax" },
      ]
    }
    return chartData
  }

  const getMonthlySalesData = (salesInfoForYear) => {
    const months = [
      { id: "1", key: 1, name: "Jan", label: "January" },
      { id: "2", key: 2, name: "Feb", label: "February" },
      { id: "3", key: 3, name: "March", label: "March" },
      { id: "4", key: 4, name: "April", label: "April" },
      { id: "5", key: 5, name: "May", label: "May" },
      { id: "6", key: 6, name: "June", label: "June" },
      { id: "7", key: 7, name: "July", label: "July" },
      { id: "8", key: 8, name: "Aug", label: "August" },
      { id: "9", key: 9, name: "Sept", label: "September" },
      { id: "10", key: 10, name: "Oct", label: "October" },
      { id: "11", key: 11, name: "Nov", label: "November" },
      { id: "12", key: 12, name: "Dec", label: "December" },
    ]

    return months.flatMap((_m) => {
      const sales = salesInfoForYear[_m.name]
      if (!sales) return [] // skip undefined months
      return {
        month: _m.key,
        tax: sales.AccumulatedTax,
        extPrice: sales.AccumulatedExtPrice,
      }
    })
  }

  return (
    <div style={{ marginBottom: isMobile ? "180px" : "20px" }}>
      {/* LAST UPDATED HEADER */}

      {/* <div className="VA-H1-LABEL-DIV" style={{ marginLeft: "20px" }}>
        <Typography variant="h3" gutterBottom className="VA-H1-LABEL" sx={{ mb: 1, mt: 0, fontSize: "30px" }}>
          Prepaid Recon - {selectedClientInfo?.label}
        </Typography>
      </div> */}

      {hasDemoAccess && (
        <div
          style={{
            position: "fixed",
            top: 15,
            right: 30,
            padding: "10px 20px",
            background: "linear-gradient(135deg, #ff416c, #ff4b2b)", // vibrant gradient
            color: "#fff",
            borderRadius: "20px",
            fontSize: 12,
            fontWeight: 600,
            zIndex: 9999,
            backdropFilter: "blur(6px)",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            cursor: "default",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "bounce 1.5s infinite alternate",
          }}
        >
          Demo Data
        </div>
      )}

      <div
        className="demo-cta-wrapper"
        style={{
          position: "fixed",
          bottom: 30,
          right: 30,
          zIndex: 9999,
        }}
      >
        <div className="demo-cta-inner">
          {/* <Button
            onClick={() => window.open("https://calendly.com/farhan-prepaidrecon/30min", "_blank")}
            sx={{
              px: 6,
              py: 1.6,
              fontWeight: 700,
              fontSize: 14,
              borderRadius: "999px",
              textTransform: "none",
              letterSpacing: "0.3px",

              background: "linear-gradient(135deg, var(--va-primary-color), var(--va-primary-color-1))",
              color: "#fff",

              boxShadow: "0 10px 26px rgba(26, 43, 194, 0.28)",
              transition: "box-shadow 0.25s ease, transform 0.25s ease",

              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 16px 36px rgba(26, 43, 194, 0.38)",
              },

              "&:active": {
                transform: "translateY(0)",
                boxShadow: "0 8px 18px rgba(26, 43, 194, 0.25)",
              },
            }}
          >
            Schedule Your Demo
          </Button> */}

          {!openModal && (
            <>
              <div className="demo-cta-text">
                <span>Ready to Boost Your Performance?</span>
                <br />
                <span
                  style={{
                    color: "var(--va-primary-color)",
                    fontWeight: 700,
                  }}
                >
                  Schedule Your 30-Minute Session
                </span>
              </div>
              <Button
                onClick={handleOpenSchedule}
                sx={{
                  px: 6,
                  py: 1.6,
                  fontWeight: 700,
                  fontSize: 14,
                  borderRadius: "999px",
                  textTransform: "none",
                  letterSpacing: "0.3px",
                  background: "linear-gradient(135deg, var(--va-primary-color), var(--va-primary-color-1))",
                  color: "#fff",
                  boxShadow: "0 10px 26px rgba(26, 43, 194, 0.28)",
                  "&:hover": { transform: "translateY(-2px)", boxShadow: "0 16px 36px rgba(26, 43, 194, 0.38)" },
                  "&:active": { transform: "translateY(0)", boxShadow: "0 8px 18px rgba(26, 43, 194, 0.25)" },
                }}
              >
                Schedule Your Demo
              </Button>
            </>
          )}

          <DemoQuestionnaireModal open={openModal} onClose={handleModalClose} onSubmit={handleQuestionnaireSubmit} handleCTAClick={handleOpenSchedule} />

          {console.log("feedbackSubmitted", feedbackSubmitted)}
        </div>
      </div>

      {!feedbackSubmitted && hasDemoAccess && !openModal && <SmartFeedbackSystem startTimer={isMobile ? feedbackTimerStarted : true} handleCTAClick={handleCTAClick} />}

      <div
        style={{
          padding: "0px 20px",
        }}
      >
        <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
          <AppealsInfo />

          <AppealsPie appealsInfo={appealsInfo} />
          <AppealsInfoGroupBy />
          <EmployeeList />

          {/* <SalesInfo /> */}
          {/* <SalesInfo2 /> */}
        </div>

        {salesInfo ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {Object.entries(salesInfo).map(([year, months]) =>
              Object.entries(months).map(([month, info]) => (
                <div>
                  <Card
                    key={`${year}-${month}`}
                    sx={{
                      width: "100%",
                      maxWidth: 600,
                      margin: "60px 10px",
                      minWidth: 500,
                      display: "inline-block",
                      minHeight: 250,
                    }}
                  >
                    <CardContent>
                      <Typography variant="h5" gutterBottom>
                        Sales Info Breakdown - {month}, {year}
                      </Typography>

                      {/* Optionally render a pie chart */}
                      <VAPieChart chartData={convertToChartData(info)} />

                      {/* {Object.entries(info).map(([label, value]) => (
                      <Typography key={label} variant="body1">
                        {label}: {value.toLocaleString()}
                      </Typography>
                    ))} */}
                    </CardContent>
                  </Card>
                </div>
              ))
            )}
            {Object.entries(salesInfo).map(([year, months]) => {
              const lineData = getMonthlySalesData(months)
              return (
                <Card key={`line-${year}`} sx={{ width: "100%", maxWidth: 800, margin: "40px 10px" }}>
                  <CardContent>
                    <Typography variant="h5" gutterBottom>
                      Accumulated Sales Chart - {year}
                    </Typography>
                    <SalesLineChart year={year} data={lineData} />
                  </CardContent>
                </Card>
              )
            })}
          </div>
        ) : (
          <></>
          // <Typography>Loading...</Typography>
        )}
      </div>
    </div>
  )
}
export default BoostDash
